"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchFormSubmitStatus = exports.updateFormProps = exports.fetchFormProps = exports.addShareFormRecord = exports.addFormRecord = exports.fetchTemplateFormPack = exports.fetchShareFormPack = exports.fetchFormPack = void 0;
const axios_1 = __importDefault(require("axios"));
const Url = __importStar(require("./url.data"));
const urlcat_1 = __importDefault(require("urlcat"));
const baseURL = process.env.NEXT_PUBLIC_NEXT_API;
function fetchFormPack(formId) {
    return axios_1.default.get((0, urlcat_1.default)(Url.FORMPACK, { formId }), { baseURL });
}
exports.fetchFormPack = fetchFormPack;
function fetchShareFormPack(shareId, formId) {
    return axios_1.default.get((0, urlcat_1.default)(Url.READ_SHARE_FORMPACK, { shareId, formId }), { baseURL });
}
exports.fetchShareFormPack = fetchShareFormPack;
function fetchTemplateFormPack(templateId, formId) {
    return axios_1.default.get((0, urlcat_1.default)(Url.READ_TEMPLATE_FORMPACK, { templateId, formId }), { baseURL });
}
exports.fetchTemplateFormPack = fetchTemplateFormPack;
function addFormRecord(formId, recordData) {
    return axios_1.default.post((0, urlcat_1.default)(Url.FORM_ADD_RECORD, {
        formId,
    }), recordData, { baseURL });
}
exports.addFormRecord = addFormRecord;
function addShareFormRecord(formId, shareId, recordData) {
    return axios_1.default.post((0, urlcat_1.default)(Url.SHARE_FORM_ADD_RECORD, {
        formId, shareId,
    }), recordData, { baseURL });
}
exports.addShareFormRecord = addShareFormRecord;
function fetchFormProps(formId) {
    return axios_1.default.get((0, urlcat_1.default)(Url.READ_FORM_PROPS, { formId }), { baseURL });
}
exports.fetchFormProps = fetchFormProps;
function updateFormProps(formId, formProps) {
    return axios_1.default.post((0, urlcat_1.default)(Url.UPDATE_FORM_PROPS, {
        formId,
    }), formProps, { baseURL });
}
exports.updateFormProps = updateFormProps;
function fetchFormSubmitStatus(formId) {
    return axios_1.default.get((0, urlcat_1.default)(Url.READ_FORM_SUBMIT_STATUS, { formId }), { baseURL });
}
exports.fetchFormSubmitStatus = fetchFormSubmitStatus;
//# sourceMappingURL=form_api.js.map